export const getHeadersForDisplay = (): string[] => {
  return [
    'Name',
    '',
    null,
    "Companies",
    "Write-off",
    "Exit",
    null,
    "Investment",
    "Proceed",
    "Gain/(loss)",
    "MOIC",
    'Avg. check',
  ];
};

export const getHeadersForDisplayTitle = (): string[] => {
  return [
    '',
    '',
    '',
    '',
    'Portfolio performance',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ];
};

export const getHeadersForLogic = (): string[] => {
  return [
    'Name',
    '',
    'empty',
    "Companies",
    "Write-off",
    "Exit",
    'empty(1)',
    "Investment",
    "Proceed",
    "Gain/(loss)",
    "MOIC",
    'Avg. check',
  ];
};

export const getHeadersForDisplayForCommitmentAllocation = (): string[] => {
  return [ 'Commitment allocation', '', null, ''];
};

export const getHeadersForLogicForCommitmentAllocation = (): string[] => {
  return ['', 'Commitment allocation', 'empty', 'empty(0)'];
};


export const getHeadersForDisplayForFundPerformance = (): string[] => {
  return [ 'Fund performance', '', null, ''];
};

export const getHeadersForLogicForFundPerformance = (): string[] => {
  return ['', 'Fund performance', 'empty', 'empty(0)'];
};
